export enum TranslatableInputType {
  TEXT = 'TEXT',
  TEXT_AREA = 'TEXT_AREA'
}
